export default __webpack_public_path__ + "static/media/green_plus_icon.21860de6.svg";